angular.module( 'acme.view.application.partners.orders.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.partners.orders.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var partnersOrdersList = {
        name: 'application.partners.orders.list',
        url: '/list?accountId',
        views: {
          "subview-main": {
            controller: 'PartnersOrdersListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/partners/orders/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Organization Orders'
        },
        resolve: {
          OrdersListData: ['$stateParams', 'ApiService', function ($stateParams, ApiService) {
            return ApiService.orders.partners.list();
          }]
        }
      };

    $stateProvider
      .state(partnersOrdersList);
});
